import { Platform } from 'react-native';
import { signupAttributionAPI } from './api';
import { buildCampaignSuperProperties } from './campaignAttribution';

/**
 * Hands the campaign this visitor arrived from to the server at the moment they
 * request a login code.
 *
 * The code is delivered by email. A visitor who tapped a campaign link inside an
 * in-app browser (Instagram, TikTok) very often finishes in the system browser,
 * which is a separate storage jar: no UTMs in the URL, no persisted first touch,
 * a fresh anonymous Mixpanel id. Their email address is the only value present
 * on both sides of that jump, so the server re-attaches the campaign when the
 * account is finally created.
 */
export async function captureSignupAttribution(
  email: string,
  getDeviceId: () => string | undefined,
): Promise<void> {
  // Native installs have no URL to read a campaign from, and no browser to jump
  // out of — there is nothing to hand over.
  if (Platform.OS !== 'web') return;

  try {
    const anonDeviceId = getDeviceId();

    await signupAttributionAPI.capture({
      email,
      attribution: buildCampaignSuperProperties(),
      ...(anonDeviceId ? { anonDeviceId } : {}),
    });
  } catch {
    // The visitor is waiting for a login code. Attribution is reporting only and
    // must never surface as a send error.
  }
}
